export function parseErrorMessage(error: any, parsedMessage: string) {
  const errorMessage = error?.response?.data?.message;
  return !errorMessage || errorMessage?.includes('Internal server error')
    ? parsedMessage
    : errorMessage;
}
